import { db } from '@/firebaseInit'
const debug = require('debug')('OD::Store:Configuration')

let firebaseRef = null

const state = {
  version: null,
  needUpdate: false,
}

const getters = {}

const mutations = {
  UPDATE_PARAM(state, { param, value }) {
    debug('UPDATE_PARAM', param, value)
    state[param] = value
  },
}

const actions = {
  init({ commit, rootState, dispatch }) {
    debug('init')
    dispatch('initParam', { param: 'version' })
  },
  initParam({ commit, rootState, state }, { param }) {
    if (!firebaseRef) {
      firebaseRef = db
        .collection('configuration')
        .doc(param)
        .onSnapshot(
          doc => {
            if (doc.exists) {
              const newVersion = doc.data().value
              if (state.version && state.version !== newVersion) {
                commit('UPDATE_PARAM', { param: 'needUpdate', value: true })
              } else {
                if (state.needUpdate) {
                  commit('UPDATE_PARAM', { param: 'needUpdate', value: false })
                }
              }
              commit('UPDATE_PARAM', { param, value: doc.data().value })
            } else {
              commit('UPDATE_PARAM', { param, value: null })
            }
          },
          error => {
            debug('Error', 'initParam', 'configuration', param, error.message)
          }
        )
    } else {
      debug('Already initialize', param)
    }
  },
}

export default { namespaced: true, state, mutations, actions, getters }
